module.exports = __webpack_public_path__ + "static/media/sunset_1.6d22c84b.jpg";